import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Featurebob() {
  return (
    <section className="feature_bob">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center resp_order"
          >
            <div className="faeture_img">
              <StaticImage
                src="../../../images/case-studies/bob/feature_img_1.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1140}
                height={812}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-6 offset-lg-6 offset-md-0 mt-md-4 mt-lg-0"
          >
            <h2 style={{ color: "#000" }}>
              Features of the B.O.B Mobile Application
            </h2>
            <p>
              The B.O.B mobile application is home to some of the most
              outstanding and sophisticated features. The following are some of
              the features of the app:
            </p>
            <ul>
              <li>
                The users can enlist their business via the business listing
                feature.
              </li>
              <li>
                G.P.S. and location enable the user to track nearby companies.
              </li>
              <li>
                Map integration further solidifies the ease of navigating a
                business.
              </li>
              <li>
                Users can check the reviews of a company with the help of the
                review list.
              </li>
              <li>
                Users can explore important information like the company’s
                description, products, opening hours, and more.
              </li>
              <li>
                Users can create their own profile, signup using Facebook or
                Gmail.
              </li>
              <li>
                The push notification features keep the user coming back for
                more.
              </li>
              <li>
                Dashboard and analytics platform for the management of B.O.B.
              </li>
              <li>Robust application structure, database, and protocol.</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Featurebob;
